// Shared ordering for blockchain-network picker rows used by WithdrawScreen
// and DepositCardScreen. Keeps "TRON first, then Ethereum, then everything
// else alphabetically" consistent across the two screens. Add new known
// chains here as we onboard them — anything not listed falls back to rank 99
// and sorts alphabetically among other unknowns.
const NETWORK_RANK: Record<string, number> = {
  // TRON family
  TRC20: 1,
  TRX: 1,
  TRON: 1,
  // Ethereum family
  ERC20: 2,
  ETH: 2,
  ETHEREUM: 2,
};

/** Lookup the TRON/Ethereum-prioritised rank for a network symbol. */
export const networkRank = (symbol: string): number =>
  NETWORK_RANK[symbol.toUpperCase()] ?? 99;

/**
 * Comparator suitable for `Array.prototype.sort` that orders by network
 * rank first and falls back to alphabetical symbol within the same rank.
 * Use for arrays of (token × network) picker options where the consumer
 * already groups by token symbol.
 */
export const compareByNetwork = (
  a: { networkSymbol: string },
  b: { networkSymbol: string },
): number => {
  const ra = networkRank(a.networkSymbol);
  const rb = networkRank(b.networkSymbol);
  if (ra !== rb) return ra - rb;
  return a.networkSymbol.localeCompare(b.networkSymbol);
};
